// Mirrors medipro-backend/constants/lead.js.

export const LEAD_SOURCES = [
  { key: "facebook", label: "Facebook" },
  { key: "instagram", label: "Instagram" },
  { key: "google", label: "Google" },
  { key: "justdial", label: "JustDial" },
  { key: "practo", label: "Practo" },
  { key: "website", label: "Website" },
  { key: "whatsapp", label: "WhatsApp" },
  { key: "phone", label: "Phone call" },
  { key: "walkin", label: "Walk-in" },
  { key: "referral", label: "Referral" },
  { key: "other", label: "Other" },
];
export const SOURCE_LABEL = Object.fromEntries(LEAD_SOURCES.map((s) => [s.key, s.label]));

// Chip colour + initials for each source on the Leads screen.
export const SOURCE_STYLE = {
  facebook: { short: "f", color: "#1877F2" },
  instagram: { short: "IG", color: "#D62976" },
  google: { short: "G", color: "#EA4335" },
  justdial: { short: "JD", color: "#F7931E" },
  practo: { short: "Pr", color: "#14BEF0" },
  website: { short: "W", color: "#6D28D9" },
  whatsapp: { short: "WA", color: "#16A34A" },
  phone: { short: "☎", color: "#0F766E" },
  walkin: { short: "WI", color: "#475569" },
  referral: { short: "R", color: "#65A30D" },
  other: { short: "•", color: "#64748B" },
};

// Which door of a source the lead came through (lead.source_detail).
export const SOURCE_DETAIL_LABEL = {
  gbp_call: "Business Profile · call",
  gbp_whatsapp: "Business Profile · WhatsApp",
  gbp_website: "Business Profile · website",
  gbp_booking: "Business Profile · booking link",
  google_ads_form: "Ads lead form",
  google_ads_click: "Ads click",
};

export const LEAD_STATUS_LABEL = {
  new: "New",
  contacted: "Contacted",
  follow_up: "Follow-up",
  booked: "Appointment booked",
  converted: "Converted",
  lost: "Lost",
  junk: "Junk",
};

export const CONVERSATION_STATES = [
  { key: "pending_approval", label: "Awaiting approval" },
  { key: "needs_human", label: "Needs human" },
  { key: "bot_active", label: "Bot handling" },
  { key: "human_active", label: "With staff" },
  { key: "closed", label: "Closed" },
];
export const STATE_LABEL = Object.fromEntries(CONVERSATION_STATES.map((s) => [s.key, s.label]));

export const OUTCOMES = [
  { key: "book_appointment", label: "Book appointment" },
  { key: "follow_up", label: "Follow up later" },
  { key: "info_only", label: "Information only" },
  { key: "not_interested", label: "Not interested" },
  { key: "junk", label: "Junk / wrong number" },
];
export const OUTCOME_LABEL = Object.fromEntries(OUTCOMES.map((o) => [o.key, o.label]));

export const LEAD_CHAT_EVENT = "lead_chat";
